import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full md:w-2/3 max-w-500" }
const _hoisted_2 = { class: "summary-line text-18 md:text-20 xl:text-24" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "summary-line text-16 md:text-18 xl:text-20 mt-x3" }

import { computed, ComputedRef } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import offersStore from '@/b2c/offers/offers.store';
import {
    PersonalOfferViewModel,
} from '@/b2c/shared/api/server-apis';
import OfferSummaryTaxes from '@/b2c/offers/ui/helpers/OfferSummaryTaxes.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferSummaryMyBoliaBoost',
  setup(__props) {

const labels = useBlockLabels();

const offer: ComputedRef<PersonalOfferViewModel> = computed(() => {
    return offersStore.detail;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", _hoisted_2, [
      _createElementVNode("dt", _hoisted_3, _toDisplayString(_unref(labels).summaryTotalMemberPrice), 1),
      _createElementVNode("dd", _hoisted_4, _toDisplayString(_unref(offer).memberPrice.totalPrice), 1)
    ]),
    _createVNode(OfferSummaryTaxes, {
      "sales-tax": _unref(offer).memberPrice.salesTax
    }, null, 8, ["sales-tax"]),
    _createElementVNode("dl", _hoisted_5, [
      _createElementVNode("dt", null, _toDisplayString(_unref(labels).summaryTotalNonMemberPrice), 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(offer).totalPrice.amount), 1)
    ]),
    _createVNode(OfferSummaryTaxes, {
      "sales-tax": _unref(offer).salesTax
    }, null, 8, ["sales-tax"])
  ]))
}
}

})